module.exports = __webpack_public_path__ + "img/8E7C67_E2C6A5_3B332A_C3AB94-256px.7aec0a69.png";